webpackJsonp([3],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//

exports.default = function () {
    return _react2.default.createElement(
        'i',
        null,
        'beatfix'
    );
};

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(27);

var _Product = __webpack_require__(137);

var _Product2 = _interopRequireDefault(_Product);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//

exports.default = (0, _reactStatic.withRouteData)(function () {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'h2',
            null,
            'Features'
        ),
        _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
                'li',
                null,
                'Visual display of tempo (suitable for a dark environment)'
            ),
            _react2.default.createElement(
                'li',
                null,
                'Pick up the beat at any point in a bar/cycle (no need to wait for a new bar)'
            ),
            _react2.default.createElement(
                'li',
                null,
                'Provides a visual reference to assess accuracy of an ambient tempo'
            )
        ),
        _react2.default.createElement(
            'h3',
            null,
            'With ',
            _react2.default.createElement(_Product2.default, null),
            ', a drummer can:'
        ),
        _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
                'li',
                null,
                'Check the ambient tempo with an extended glance'
            ),
            _react2.default.createElement(
                'li',
                null,
                'Incrementally correct the ambient tempo'
            ),
            _react2.default.createElement(
                'li',
                null,
                'Monitor his/her precision at a glance'
            )
        )
    );
});

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Features.6b03eeb8.js